import { FontSizes } from 'apps/webcomponents/src/types/common/types';

export interface MapConfig {
  projectionType?: ProjectionTypes;
  countriesBackgroundColor?: string;
  countriesBorderColor?: string;
  hasLabels?: boolean;
  hasTooltip?: boolean;
  labelAnchor?: LabelAnchorOptions;
  labelAlign?: LabelAlignOptions;
  bubblesBackgroundColor?: string;
  labelBackgroundColor?: string;
  labelFontColor?: string;
  bubbleRadius?: number;
  hoverRadius?: number;
  // offset only applicable if align is start or end
  labelOffset?: number;
  labelPadding?: number;
  labelBorderRadius?: number;
  labelFontSize?: FontSizes;
  labelFontWeight?: number | LabelWeights;
  // list of countries to remove from the map, please check the correct country names in /utils/world-countries.json
  removedCountries?: string[];
}

export enum MapChartEvents {
  BUBBLE_CLICK = 'bubbleClick',
  BUBBLE_LABEL_MOUSE_ENTER = 'bubbleLabelMouseEnter',
  BUBBLE_LABEL_MOUSE_LEAVE = 'bubbleLabelMouseLeave',
}

export interface BubbleMapChartPoint {
  countryCode: string;
  value?: number;
}

export interface Country {
  country: string;
  alpha2: string;
  latitude: number;
  longitude: number;
  value?: number;
}

export enum ProjectionTypes {
  MERCADOR = 'mercator',
  EQUAL_EARTH = 'equalEarth',
}

// The label box alignment relative to the bubble
export enum LabelAnchorOptions {
  CENTER = 'center',
  END = 'end',
  START = 'start',
}

// The label box alignment relative to anchor
export enum LabelAlignOptions {
  // before the anchor point, following the same direction
  START = 'start',
  // after the anchor point, following the same direction
  END = 'end',
  // centered on the anchor point
  CENTER = 'center',
  // 0°
  RIGHT = 'right',
  // 90°
  BOTTOM = 'bottom',
  // 180°
  LEFT = 'left',
  // 270°
  TOP = 'top',
}

export enum LabelWeights {
  NORMAL = 'normal',
  BOLD = 'bold',
  BOLDER = 'bolder',
  LIGHTER = 'lighter',
}
